export default {
  title: 'Dashboard',
  text: {
    video_views: 'Video views',
    video_views_for_video: 'Video views for this video',
    learners: 'Learners',
    learners_for_video: 'Learners for this video',
    new_learners: 'New Learners',
    total_hub_new_learners: 'Hub New Learners',
    top_videos: 'Top videos',
    top_learning_path: 'Top learning paths',
    engagement_metrics: 'Engagement Metric',
    engagement_duration: 'Engagement Duration',
    total_engagement_duration: 'Total enagagement time',
    avg_engagement_duration: 'Average enagagement time per user',
    hub_avg_engagement_duration: 'Hub average enagagement time per user',
    range: 'Last 30 days',
    views: 'views',
    no_video_onboard:
      'Your dashboard seems empty! Start creating videos and train your customers!',
    share_video_onboard:
      'Your dashboard seems empty! Start sharing your videos!',
    start_sharing: 'Start sharing your collections!',
    start_sharing_videos: 'Start sharing your videos!',
    note: 'Updated every 24 hours',
    video_analytics: 'Video Level Metrics',
    step_analytics: 'Video Block Level Drilled Down Metrics',
    chapter_analytics: 'Chapter Level Drilled Down Metrics'
  }
};
